import { useState, useEffect } from "react";
import { Box, IconButton, Paper } from "@mui/material";

import MemberMovements from './MemberMovements.js'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

function Component(props) {
    const { Members, Movements, groupId, User, Means, lastReceitpNumber, cancelDebit, DbUpload, offlineMovementsUpdate, EscKeyStroke, readyToClose, removeUserFromFamilyGroup } = props;
    const [groupData, setGroupData] = useState({});
    useEffect(() => {
        let data = {
            documentonumero: '',
            apellido: '',
            nombre: `x${Object.keys(Members).length}`,
            socio: 'Grupo Familiar',
            direccion: '',
            ciudad: '',
            codpostal: ''
        }
        for (let m of Object.keys(Members).toSorted()) {
            if (!!data.documentonumero) data.documentonumero += ', ';
            data.documentonumero += Members[m].documentonumero;
            if (!data.apellido || data.apellido.length > Members[m].apellido) data.apellido = Members[m].apellido;
            if (!data.direccion && !!Members[m].direccion) {
                data.direccion = Members[m].direccion;
                data.ciudad = Members[m].ciudad;
                data.codpostal = Members[m].codpostal;
            }
        }
        setGroupData(data)
    }, [Members])

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 3,
                p: 3,
                width: '100%',
                height: '100%',
                overflow: 'none',
            }}
        >
            <Box
                sx={{
                    flex: { xs: '1 1 50%', md: '1 1 30%' },
                }}>
                <MemberMovements
                    User={User}
                    MemberData={groupData}
                    MovementsData={Movements[groupId] || {}}
                    MemberId={groupId}
                    Means={Means}
                    lastReceitpNumber={lastReceitpNumber}
                    cancelDebit={cancelDebit}
                    DbUpload={DbUpload}
                    offlineMovementsUpdate={offlineMovementsUpdate}
                    EscKeyStroke={EscKeyStroke}
                    readyToClose={() => { }}
                />
            </Box>
            <Box
                sx={{
                    flex: { xs: '1 1 50%', md: '1 1 70%' },
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                    gap: 3,
                    height: '100%',
                }}>
                {Object.keys(Members).map(m => (
                    <Paper
                        key={`GroupMemberMovement-${m}`}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            maxHeight: '40vh',
                            pt:1,
                            mb:1,
                            mx:-1,
                        }}
                    >
                        <Box
                            sx={{ fontSize: 24, fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                            <Box
                                onClick={() => window.location.hash = `socio?${m}`}
                            >

                                {`(${Members[m].socio || ''}) ${Members[m].nombre || ''} ${Members[m].apellido || ''}`}
                            </Box>
                            <IconButton
                                size="small"
                                onClick={() => removeUserFromFamilyGroup(m)}
                            >
                                <PersonRemoveIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        <MemberMovements
                            User={User}
                            MemberData={Members[m] || {}}
                            MovementsData={Movements[m] || {}}
                            MemberId={m}
                            Means={Means}
                            lastReceitpNumber={lastReceitpNumber}
                            cancelDebit={cancelDebit}
                            DbUpload={DbUpload}
                            offlineMovementsUpdate={offlineMovementsUpdate}
                            EscKeyStroke={EscKeyStroke}
                            readyToClose={() => { }}
                            minimal={true}
                        />
                    </Paper>
                ))}
            </Box>
        </Box>
    )
}

export default Component;